import { render, staticRenderFns } from "./SettingsDiscountMembers.vue?vue&type=template&id=da0481ac&"
import script from "./SettingsDiscountMembers.vue?vue&type=script&lang=js&"
export * from "./SettingsDiscountMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports